import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { setAccessToken } from "../services/api";
import "./Otp.css";
import AccountHomeButton from "../pages/Auth/account-home-button";

const BusinessOtp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (value, index) => {
    if (isNaN(value)) return;
    const n = [...otp];
    n[index] = value;
    setOtp(n);
    if (value !== "" && index < 5) inputRefs.current[index + 1].focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const businessUserId = location.state?.businessUserId;
    if (!businessUserId) return alert("Missing business user ID.");
    try {
      const code = otp.join("");
      const { data } = await api.post("/business-verify-otp", { businessUserId, otp: code });
      setAccessToken(data.accessToken);
      alert("OTP verified successfully!");
      navigate("/bus-dashboard/business/user/profile");
    } catch {
      alert("Invalid or expired OTP.");
    }
  };

  return (
    <div className="otp-body">
      <AccountHomeButton />
      <div className="otp-container">
        <h2>Business User OTP</h2>
        <form onSubmit={handleSubmit}>
          <div className="otp-inputs">
            {otp.map((v, i) => (
              <input
                key={i}
                type="text"
                maxLength="1"
                value={v}
                onChange={(e) => handleChange(e.target.value, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                ref={(el) => (inputRefs.current[i] = el)}
              />
            ))}
          </div>
          <button type="submit">Verify</button>
        </form>
      </div>
    </div>
  );
};

export default BusinessOtp;
